import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import ReactScrollbarCustom from 'react-scrollbars-custom';
import { makeStyles } from 'tss-react/mui';
import styles from './Scrollbar.styles';

const useStyles = makeStyles()(styles);

const ScrollbarPart = props => {
    const { elementRef, ...remain } = props;
    return <div ref={elementRef} {...remain} />;
};

ScrollbarPart.propTypes = {
    elementRef: PropTypes.any,
};

const Scrollbar = props => {
    const { className, contentPaddingRight, contentPaddingBottom, dark, style, ...remain } = props;
    const { classes, cx } = useStyles();
    const reserve = contentPaddingRight > 0;
    const reserveBottom = contentPaddingBottom > 0;

    const componentProps = useMemo(
        () => ({
            wrapperProps: {
                className: classes.wrapper,
            },
            scrollerProps: {
                className: classes.scrollArea,
            },
            contentProps: {
                className: classes.content,
            },
            trackXProps: {
                className: cx(classes.track, classes.trackHorizontal),
            },
            trackYProps: {
                className: cx(classes.track, classes.trackVertical),
            },
            thumbXProps: {
                className: cx(classes.thumb, classes.thumbHorizontal),
            },
            thumbYProps: {
                className: cx(classes.thumb, classes.thumbVertical),
            },
        }),
        [
            classes.wrapper,
            classes.scrollArea,
            classes.content,
            classes.track,
            classes.trackHorizontal,
            classes.trackVertical,
            classes.thumb,
            classes.thumbHorizontal,
            classes.thumbVertical,
        ]
    );

    return (
        <ReactScrollbarCustom
            createContext
            noDefaultStyles
            disableTracksWidthCompensation
            className={cx(
                classes.root,
                dark ? classes.dark : '',
                {
                    [classes.contentReserve]: reserve,
                    [classes.contentReserveBottom]: reserveBottom,
                },
                className
            )}
            style={
                reserve || reserveBottom
                    ? {
                          ...style,
                          ...(reserve && {
                              '--sb-content-pad': `min(${contentPaddingRight}px, 100vw)`,
                          }),
                          ...(reserveBottom && {
                              '--sb-content-pad-bottom': `${contentPaddingBottom}px`,
                          }),
                      }
                    : style
            }
            {...remain}
            renderer={ScrollbarPart}
            {...componentProps}
        />
    );
};

Scrollbar.propTypes = {
    className: PropTypes.string,
    contentPaddingRight: PropTypes.number,
    contentPaddingBottom: PropTypes.number,
    dark: PropTypes.bool,
    style: PropTypes.object,
};

export default Scrollbar;
